import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BackButton, PageSectionTitle as SectionTitle } from '@applyonline/shared';
import { useTranslation } from 'react-i18next';
const ErrorPage = ({ title, description, showBackButton = false, backHref = '/', }) => {
    const { t } = useTranslation('shared');
    const resolvedTitle = title ?? t('common.notFound');
    const resolvedDescription = description ?? t('common.unexpectedError');
    return (_jsxs("main", { className: "step-0", children: [_jsx(SectionTitle, { title: resolvedTitle }), _jsx("h1", { children: t('common.oopsTitle') }), _jsx("div", { className: "paragraph", children: resolvedDescription }), showBackButton && _jsx(BackButton, { href: backHref })] }));
};
export default ErrorPage;
